// extracted by mini-css-extract-plugin
export default {"terms-and-conditions":"TermsAndConditions_terms-and-conditions__S0ncB"};